import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export const IMG_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: API_BASE,
});

// Attach token automatically to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('jsToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally — logout if token expired
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('jsToken');
      localStorage.removeItem('jsUser');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
